import React, {Component} from 'react';
//import MonthCard from "./_MonthCard";
import DealCard from "../../features/DealCard";
import YearCard from "./YearCard"
import Dragscrolles from 'dragscrolles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faAngleUp, faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";
import configData from '../../config/config.json';
import { withTranslation } from 'react-i18next';

const API_ENDPOINT = configData.API_ENDPOINT;


//import Flights from "./Flights"


class Deck extends Component {
    
    constructor(props) {
        super(props)
        //console.log(props)
            

        this.selectedMonth = this.props?.selectedMonth;

        this.counter  = 0;
        this.yPosition = 0;

        this.state = {
            'showmore': 3,
            'active': true,
            //'data' : this.props.data,
            'sort' : 'price',
            'filters': this.props.filters
        }
        
         // Load airlines baggage only once
         /*
         if (this.state?.baggage==null) {

            const res = fetch(API_ENDPOINT + `/search/airlines/baggage`) // /${this.props.data.flight.outbound.airline.code}/${this.props.data.flight.outbound.arrival_iata}
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw new Error(this.props.t('common.errors.network.error309'));
                    }
                }).then(data=>{
                    this.setState((prevState)=>({
                        ...prevState,
                        baggage: data,
                    }))
                }).catch(error=>{
                    console.log(error)
                    throw new Error(this.props.t('common.errors.network.error309'));
                });
            
        }*/

        //binding
        this.handleSort = this.handleSort.bind(this); 
        this.toggleMore = this.toggleMore.bind(this); 
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.handleSort = this.handleSort.bind(this); 
        this.selectMonth = this.selectMonth.bind(this);


    }

    componentDidMount() {

        const scrolls = document.querySelectorAll('.scroll');

        scrolls.forEach((scroll) => {
            new Dragscrolles(scroll);
        });
    }

    next() {
        this.slider.slickNext();
    }
      
    previous() {
        this.slider.slickPrev();
    }

    /** 
     * Sort array by either price or day/month
    */
    sortArray = (array, sortBy) => {
        
        const daysOrMonths = JSON.parse(JSON.stringify(array)); // Copy the array by value (not by reference)
        //console.log(daysOrMonths)
        // Remove all non related stars deals
        /*array.map(
            (day, index) => {
                const deal = day.deals.filter(deal=>
                    deal.property.stars == stars);
                daysOrMonths[index].deals = deal;
            }
        );*/

        return sortBy=='counter'?
            daysOrMonths.sort((a,b) => ((a.year+('0'+a.id).slice(-2))-(b.year+('0'+b.id).slice(-2)))): // we're using slice(-2) to add zero padding => reference to the slice(-2): https://stackoverflow.com/questions/3605214/javascript-add-leading-zeroes-to-date
            daysOrMonths.sort((a,b) => a.deals[0]?.price-b.deals[0]?.price)
    }

    // Handle sort button
    handleSort = (sortBy) => {
        //console.log('SORT')
        this.setState(
            {
                data: 
                    sortBy=='counter'?
                        this.sortArray(this.props.data, 'counter'):
                        this.sortArray(this.props.data, 'price'),
                sort: sortBy
            }
        );
    }


    selectMonth = (evt, year, month) => {
        console.log(`selectMonth ${year} ${month}`)
        this.selectedMonth = {
            year: year,
            month: month
        } // month is 0 based, so we need to add 1
        
        // rerender
        this.forceUpdate();

        this.props.callback(evt, year, month)
        
    }

    toggleMore = (evt) => {

        evt.preventDefault();       
        evt.stopPropagation()

        window.dataLayer = window.dataLayer || [];
        const event_name = 'ShowMoreCategoryResults';
        console.log('GTM event: ' + event_name)
        window.dataLayer.push({
            page: 'destination/month',
            event: event_name,
            //name: stars,
            //stars: stars,
            'pageUrl': window.location,
            'pageTitle' : window.title,
        });
        
        this.setState(prevState => ({
            ...prevState,
            active: true,
            sort: prevState.sort,
            filters: {
                ...this.props.filters,
                'page': (this.props?.filters?.page)?++this.props.filters.page:2,
                'loading_deals': true,
                'no_more_deals': false
            }
            /*'text':     (!prevState.showfor3stars.showMore ? "הסתר" : " תאריכים נוספים" ),
            'card_deals': prevState.showMore?this.data_source.slice(0,13):this.data_source,
            'fa_arrow': (!prevState.showMore ? "fa fa-sort-up" : "fa fa-sort-down" ),
            'showMore' : !prevState.showMore*/
        }), () => {
            this.props.sendDataToCaller(this.state.filters, false)
        });
        
    }

    /**
         * Track the existing scrollbar position
         * 
         * @param {*} e 
         */
    scrollButtonToggle = (scrollContainer, cardIndex, cardsCount) => {

        const btnLeft = scrollContainer.parentElement.getElementsByClassName('btn left')[0];
        const btnRight = scrollContainer.parentElement.getElementsByClassName('btn right')[0];
   
        if (cardIndex > 0)
            btnRight.style.display = 'block'
        else
            btnRight.style.display = 'none'

        if (cardIndex < cardsCount)
            btnLeft.style.display = 'block'
        else
            btnLeft.style.display = 'none'

    }

    /**
     * Get up-to-date y axis position when scrolling by dragging
     * @param e 
     */
    scrollHandler = (e) => {
        e.stopPropagation();
        this.yPosition = e.target.scrollLeft           
        //console.log(yPosition)
    }

    scrollButtonClickHandler = (e, direction)  => {

        e.stopPropagation();
        
        var scrollContainer =  e.target.parentElement.parentElement.parentElement.getElementsByClassName("scroll")[0]
        var scrollContainerItems = scrollContainer.getElementsByClassName("scrollItem");
        
        // claculate the gap between 2 cards
        var gapSize = scrollContainerItems[1].offsetLeft - scrollContainerItems[0].offsetLeft

        // Find the closest index to the existing y-Position
        let scrollItemIndex = Math.abs(parseInt(this.yPosition/gapSize));

        // Calculate the new index
        if (direction == 'right') {
            if (scrollItemIndex > 0)
                scrollItemIndex=scrollItemIndex-1;
        } else {
            if (scrollItemIndex < scrollContainerItems.length)
                scrollItemIndex=scrollItemIndex+1
        }

        // Scroll to new card
        scrollContainer.scrollTo({
            top: 0,
            //left: scrollContainerItems[newCardIndex].offsetLeft,
            left: scrollItemIndex * gapSize,
            behavior: "smooth"
        });

        // Toggle next & previous buttons
        this.scrollButtonToggle(scrollContainer, scrollItemIndex, scrollContainerItems.length-1)


    }

    getStars = (stars) => {

        let starsCaption = '';

        switch(stars) {
            case '3': starsCaption='★★★';break;
            case '4': starsCaption='★★★★';break;
            case '5': starsCaption='★★★★★';break;
        }

        return starsCaption;
    }    

    

    render() {
        this.selectedMonth = this.props?.selectedMonth;

        this.counter = 0;

        if ( this.props.ready && this.props.data?.length===0 ) {
            window.dataLayer = window.dataLayer || [];
            const event_name = 'NoSearchResultsInDestination';
            console.log('GTM event: ' + event_name)
            window.dataLayer.push({
                page: 'Destination',
                event: event_name,
                'pageUrl': window.location,
                'pageTitle' : window.title,
            });

            return (
                <div>
                <h2>{this.props.t('destination.messages.noResultsFound')}</h2>
                <h3>{this.props.t('destination.messages.changeSearchPreferences')}</h3>
                </div>
            );
        }

        

      

           
            let source_data = this.props?.data;
            const monthsData = source_data.sort((a,b)=>new Date(a.year,a.id,1).getTime()-new Date(b.year,b.id,1).getTime()).map((item,idx) => 
                (
                    item.deals.length>0?
                        <YearCard key={`YearCard${idx}`} highlightCheapestMonth={this.props.cheapestMonth ? this.props.cheapestMonth.year == item.year && this.props.cheapestMonth.month == item.id+1 : false} selected={this.selectedMonth ? this.selectedMonth.year == item.year && this.selectedMonth.month == item.id+1 : false} data={item} callback={this.selectMonth} member={this.member} key={'monthcard'+(this.counter++)} id={'monthcard'+(this.counter)} type={this.props.type} min_price={item} destination={this.props.destination} stars={this.props?.stars} meals={this.props.meals} nights={this.props.nights}  adults={this.props.adults} teens={this.props.teens}  children={this.props.children} infants={this.props.infants} dow={this.props.dow} waterpark={this.props?.waterpark} luxury={this.props?.luxury} casino={this.props?.casino} near_chabad={this.props?.near_chabad} spa={this.props?.spa} airlines={this.props?.airlines} t={this.props.t} />:<></>
                )
            )
        


        //this.state.data = cardsData

/*        if (window.location.pathname.indexOf('flights')>0) 
           cardsData = this.props.data.map(item => <Flights data={item} key={this.counter++} />); 
*/

        //let cardsData = deckData.filter(item => item.flights!=null)
        //const deckData = this.props.data;
        //const dd  = this.prepareOutput(deckData);
     
        /*cardsData = cardsData
            .filter(function(item) {
                let flights = item.flights;
                flights = flights.filter(flight => flight.flyFrom = 'ETMr');
                item.flights = flights;
                return item;
                }).map(item => <Card data={item}/>)*/
        //cardsData = cardsData.filter(item => item.flights.filter(flight => flight.price > 300))
        //card_flights = cardsData.filter(item=> item.flights);
        //card_flights = card_flights.filter (flight => flight.price > 300);
        //cardsData = cardsData.map(item => <Card data={item}/>)

        
        //let scrollItemIndex = 0;

    
    
        //return this.props.type == 'months'?(
        
            return (
                <div>
                    {/*<div style={{margin:'1.5em 0 1em', fontWeight:'800'}}>בחרו חודש לצפיה בדילים הכי זולים</div>*/}
                    <div className="deck noselect" key='deck_key1' >
                        <div className="container months-deck-container">
                        {monthsData}</div>
                    </div>
                </div>
            )
                
          
    }
}
/*
function Deck() {

    const cardsData = deckData.map(item => <Card data={item}/>)

    return (
        <div className="deck">
            {cardsData}
        </div>

    )
}*/

export default withTranslation()(Deck)